import actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const state = {
  bottles: []
}

export default {
  state,
  actions,
  mutations,
  getters
}
